export default __webpack_public_path__ + "static/iconTop-46d76904bfa3540a7b602ace1d839de5.png";